import { makeStyles } from "@material-ui/core"
import { themeColors, FONT } from "letalkui"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(theme => ({
	previewLabel: {
		fontWeight: FONT.fontWeight.bold,
		fontSize: "12px",
		color: themeColors.colors.system.gray[500],
		textTransform: "uppercase",
		marginBottom: "8px"
	},
	previewCanvas: {
		background: `linear-gradient(310deg, ${colors.purple[100]}, ${colors.beige[100]})`,
		borderRadius: "8px",
		padding: theme.spacing(2)
	},
	previewBubble: {
		backgroundColor: themeColors.colors.system.green[50],
		borderRadius: "8px",
		padding: "10px 12px",
		width: "100%",
		boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.13)"
	},
	previewPlaceholder: {
		fontSize: "14px",
		fontStyle: "italic",
		color: themeColors.colors.system.gray[500]
	},
	previewHeader: {
		fontWeight: FONT.fontWeight.bold,
		fontSize: "14px",
		color: themeColors.colors.system.gray[950],
		marginBottom: "4px"
	},
	previewBody: {
		fontSize: "14px",
		color: themeColors.colors.system.gray[900],
		whiteSpace: "pre-wrap",
		wordBreak: "break-word"
	},
	previewFooter: {
		fontSize: "12px",
		color: themeColors.colors.system.gray[500],
		marginTop: "4px"
	},
	previewActionButton: {
		fontSize: "14px",
		color: themeColors.colors.system.green[600],
		textAlign: "center",
		paddingTop: "8px",
		borderTop: `1px solid ${themeColors.colors.system.gray[200]}`,
		marginTop: "8px",
		cursor: "pointer"
	},
	characterCounter: {
		fontSize: "12px",
		color: themeColors.colors.system.gray[500],
		textAlign: "right",
		marginTop: "4px"
	}
}))

export default useStyles
